import { ID, ISelectOption } from './utils';

export enum ProtocolStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
}

export interface IProtocol {
  id: string;
  slug: string;
  name: string;
  description: string;
  clinicId: ID;
  status: ProtocolStatus;
  createdAt: string;
  updatedAt: string;
}

export type ProtocolView = Pick<IProtocol, 'id' | 'name' | 'description' | 'clinicId' | 'status'>;

export type SelectOptionProtocol = ISelectOption<ProtocolView>;
